module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-04@2x.32a9d959.jpg";